import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { DatePickerInput, DatesProvider } from '@mantine/dates';

//redux
import { setRequireCloseModal } from '../../../../slices/fuelSupply/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
	addNewFuelSupply,
	getFuelSupplyList,
	updateFuelSupply,
} from '../../../../slices/fuelSupply/thunk';
import OSelect from '../../../../Components/OElements/OSelect';
import {
	getEstablishmentList,
	getFeedingBargesList,
	getFuelSupplyTypeList,
} from '../../../../helpers/establishment/backend_helper';
import {
	getTransferCompanyList,
	getTransferList,
} from '../../../../helpers/transfer/backend_helper';
import { getFileType } from '../../../../helpers/file_manager/backend_helper';
import OHr from '../../../../Components/OElements/OHr';
import {
	addNewBulkNotification,
	getEstablishment,
	getFuelSupplyTypeCode,
	getFuelTankListByEstablishment,
	getUserByRoles,
	sendNewEmailMessage,
	uploadFile,
} from '../../../../slices/thunks';
import { useUser } from '../../../../Components/Hooks/useUserHooks';
import OInput from '../../../../Components/OElements/OInput';

const SetBalanceSupplyForm = ({
	establishment_id,
	dataFuelSupply,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();
	const { user } = useUser();

	const [fuelTank, setFuelTank] = useState('-');
	const [feedingBarges, setFeedingBarges] = useState('-');
	const [feedingBargesId, setFeedingBargesId] = useState(null);
	const [fuelTypeId, setFuelTypeId] = useState(null);
	const [unitMeasurementName, setUnitMeasurement] = useState('-');
	const [capacity, setCapacity] = useState('-');
	const [stock, setStock] = useState('-');
	const [type, setType] = useState('-');
	const [direction, setDirection] = useState(null);
	const [supplyType, setSupplyType] = useState(null);
	const [company, setCompany] = useState(null);
	const [establishment, setEstablishment] = useState(null);
	const [selectedEstablishment, setSelectedEstablishment] = useState(null);
	const [selectedTransferEstablishment, setSelectedTransferEstablishment] =
		useState(null);
	const [transferTankFuelSelect, setTransferTankFuelSelect] = useState(null);
	const [typeDocument, setTypeDocument] = useState(null);
	const [transfer, setTransfer] = useState(null);
	const [category, setCategory] = useState('-');
	const [name_direction, setNameDirection] = useState('-');
	const [name_type_document, setNameTypeDocument] = useState('Documento');
	const [code_type_document, setCodeTypeDocument] = useState('VC,GD,AUT');
	const [fileName, setFileName] = useState('');

	const [isLoading, setIsLoading] = useState(false);

	const [transferKey, setTransferKey] = useState(`transfer || ''}`);

	const [transferCompanyCol, setTransferCompanyCol] = useState(true);
	const [fileCol, setFileCol] = useState(true);
	const [fileColNumberDoc, setFileColNumberDoc] = useState(true);
	const [establishmentCol, setEstablishmentCol] = useState(true);
	const [fuelTankCol, setFuelTankCol] = useState(true);
	const [powerGenerationSourceCol, setPowerGenerationSourceCol] =
		useState(true);

	const [requiredDescription, setRequiredDescription] = useState(true);

	const [establishmentsListSelect, setEstablishmentListSelect] = useState([]);
	const [
		transferEstablishmentsListSelect,
		setTransferEstablishmentListSelect,
	] = useState([]);

	const [selectFuelSupplyType, setSelectFuelSupplyType] = useState(null);

	const selectorFuelSupply = createSelector(
		state => state.FuelSupply,
		result => ({
			isAdding: result.isAdding,
			isAdded: result.isAdded,
			isUpdating: result.isUpdating,
			isUpdated: result.isUpdated,
			isLoadingList: result.isLoadingList,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorFuelSupply);

	const selectorEstablishment = createSelector(
		state => state.Establishments,
		result => ({
			itemEstablishmentDetail: result.itemEstablishmentDetail,
		})
	);
	const { itemEstablishmentDetail } = useSelector(selectorEstablishment);

	useEffect(() => {
		dispatch(getEstablishment(establishment_id));
	}, [establishment_id]);

	const selectorUser = createSelector(
		state => state.Roles,
		result => ({
			users: result.itemUserRoleList,
		})
	);
	const { users } = useSelector(selectorUser);

	const selectorFuelSupplyTypeCode = createSelector(
		state => state.FuelSupplyType,
		data => ({
			itemFuelSupplyTypeDetail: data.itemFuelSupplyTypeDetail,
		})
	);
	const { itemFuelSupplyTypeDetail } = useSelector(selectorFuelSupplyTypeCode);

	useEffect(() => {
		dispatch(getFuelSupplyTypeCode('transfer_in'));
	}, [establishment_id]);

	const selectorFuelTank = createSelector(
		state => state.FuelTank,
		data => ({
			fuelTankListSelect: data.fuelTankListSelect,
		})
	);
	const { fuelTankListSelect } = useSelector(selectorFuelTank);

	useEffect(() => {
		dispatch(
			getFuelTankListByEstablishment({ establishment_id: establishment_id })
		);
	}, [establishment_id]);

	useEffect(() => {
		if (fuelTankListSelect) {
			const establishments = fuelTankListSelect
				.map(option => {
					const est = option.item.establishment;
					return est
						? {
								item: option.item,
								value: est._id,
								label: est.name,
						  }
						: null;
				})
				.filter(Boolean)
				.filter(
					(est, index, self) =>
						index === self.findIndex(e => e.value === est.value)
				); // elimina duplicados por establishment_id

			setEstablishmentListSelect(establishments);
		}
	}, [fuelTankListSelect]);

	// validation
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			amount: (dataFuelSupply && dataFuelSupply.amount) || '',
			supply_date: (dataFuelSupply && dataFuelSupply.supply_date) || '',
			fuel_tank_id: '',
			fuel_type_id: (dataFuelSupply && dataFuelSupply.fuel_type_id) || '',
			fuel_supply_type_id: '',
			observation: (dataFuelSupply && dataFuelSupply.observation) || '',
			productive_cycle_id:
				(dataFuelSupply && dataFuelSupply.productive_cycle_id) || '',
			transfer_company_id:
				(dataFuelSupply && dataFuelSupply.transfer_company_id) || '',
			transfer_id: (dataFuelSupply && dataFuelSupply.transfer_id) || '',
			file_type_id: (dataFuelSupply && dataFuelSupply.file_type_id) || '',
			transfer_establishment_id:
				(dataFuelSupply && dataFuelSupply.transfer_establishment_id) || '',
			transfer_fuel_tank_id:
				(dataFuelSupply && dataFuelSupply.transfer_fuel_tank_id) || '',
			document_number:
				(dataFuelSupply && dataFuelSupply.document_number) || '',
			document: (dataFuelSupply && dataFuelSupply.document) || '',
			stock: 0,
			feeding_barges_id:
				(dataFuelSupply && dataFuelSupply.feeding_barges_id) || '',
			establishment_id:
				(dataFuelSupply && dataFuelSupply.establishment_id) ||
				establishment_id,

			select_establishment_id: null,
			select_transfer_establishment_id: null,
		},
		validationSchema: Yup.object({
			stock: Yup.number()
				.required('Campo requerido')
				.test(
					'stock-available',
					'El estanque no tiene stock',
					function (value) {
						return value == 0 && direction === 'OUT' ? false : true;
					}
				),
			amount: Yup.number()
				.required('Campo requerido')
				.notOneOf([0], 'El valor no puede ser cero')
				.test(
					'max-capacity',
					'Se supera la capacidad del estanque',
					function (value) {
						if (direction === 'IN') {
							return value + this.parent.stock <= capacity;
						}
						return true;
					}
				)
				.test(
					'positive-balance',
					'No puede quedar el estanque con saldo negativo',
					function (value) {
						if (direction === 'OUT') {
							return this.parent.stock - value >= 0;
						}
						return true;
					}
				),

			fuel_tank_id: Yup.string().required('Campo requerido'),
			supply_date: Yup.string().required('Campo requerido'),
			fuel_supply_type_id: Yup.string().required('Campo requerido'),
			observation: Yup.string().nullable(),

			transfer_company_id: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!transferCompanyCol && !value) {
							return false;
						}
						return true;
					}
				),

			transfer_id: Yup.string().nullable(),
			// .test('required-transfer-company', 'Campo requerido', function (value) {
			// 	if (!transferCompanyCol && !value) {
			// 		return false;
			// 	}
			// 	return true;
			// }),

			file_type_id: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!fileCol && !value) {
							return false;
						}
						return true;
					}
				),

			document_number: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!fileColNumberDoc && !value) {
							return false;
						}
						return true;
					}
				),

			document: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!fileCol && !value) {
							return false;
						}
						return true;
					}
				),
			transfer_establishment_id: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!establishmentCol && !value) {
							return false;
						}
						return true;
					}
				),
			transfer_fuel_tank_id: Yup.string()
				.nullable()
				.test(
					'required-transfer-company',
					'Campo requerido',
					function (value) {
						if (!fuelTankCol && !value) {
							return false;
						}
						return true;
					}
				),

			observation: Yup.string()
				.nullable()
				.test('required-observation', 'Campo requerido', function (value) {
					if (requiredDescription && !value) {
						return false;
					}
					return true;
				}),
			select_establishment_id: Yup.string().nullable(),
			select_transfer_establishment_id: Yup.string().nullable(),
		}),
		onSubmit: async values => {
			setIsLoading(true);
			// const balance =
			// 	direction === 'IN'
			// 		? Number(values.stock) + Number(values.amount)
			// 		: Number(values.stock) - Number(values.amount);

			let doc_id = null;
			const folderPath =
				'/' +
				itemEstablishmentDetail.establishment_type.name +
				'/' +
				itemEstablishmentDetail.code_siep +
				' - ' +
				itemEstablishmentDetail.name +
				'/Abastecimiento/Combustible';
			if (values.document) {
				const formData = new FormData();
				formData.append('file', values.document);
				try {
					const responseUploadFile = await dispatch(
						uploadFile({
							file_path: folderPath,
							file_type_id: typeDocument._id,
							formData: formData,
						})
					).unwrap();
					doc_id = responseUploadFile._id;
				} catch {
					setIsLoading(false);
					console.error('Error al subir archivo:', error);
				}
			}

			const supplyDate = new Date(values.supply_date);
			const now = new Date();

			// Establecer la hora actual en la fecha seleccionada
			supplyDate.setHours(now.getHours());
			supplyDate.setMinutes(now.getMinutes());
			supplyDate.setSeconds(now.getSeconds());
			supplyDate.setMilliseconds(now.getMilliseconds());

			const fuelSupply = {
				amount: values.amount,
				supply_date: supplyDate, // ahora incluye la hora actual
				fuel_tank_id: values.fuel_tank_id,
				fuel_type_id: values.fuel_type_id,
				fuel_supply_type_id: values.fuel_supply_type_id,
				observation: values.observation,
				productive_cycle_id: values.productive_cycle_id,
				establishment_id: values.establishment_id,
				// stock: values.stock,
				// balance: balance,
				unit_measurement_id: fuelTank.unit_measurement_id,
			};

			// Si transferCompanyCol es false, agregar los campos adicionales
			if (!transferCompanyCol) {
				fuelSupply.transfer_company_id = values.transfer_company_id;
				fuelSupply.transfer_id = values.transfer_id;
				fuelSupply.file_type_id = values.file_type_id;
			}
			if (!establishmentCol) {
				fuelSupply.transfer_establishment_id =
					values.transfer_establishment_id;
			}
			if (!fuelTankCol) {
				fuelSupply.transfer_fuel_tank_id = values.transfer_fuel_tank_id;
			}
			if (!fileCol) {
				fuelSupply.file_id = doc_id;
				fuelSupply.document_number = values.document_number;
				fuelSupply.file_type_id = values.file_type_id;
			}

			fuelSupply.feeding_barges_id = feedingBargesId;
			fuelSupply.fuel_type_id = fuelTypeId;

			if (supplyType.code == 'transfer_out') {
				fuelSupply.transfer_fuel_tank_id = values.transfer_fuel_tank_id;

				// const balance_transfer =
				// 	Number(transferTankFuelSelect.stock) + Number(values.amount);
				// fuelSupply.transfer_establishment_id =
				// 	transferTankFuelSelect.establishment._id;

				const fuelSupplyTransfer = {
					amount: values.amount,
					supply_date: values.supply_date,
					fuel_tank_id: values.transfer_fuel_tank_id,
					transfer_fuel_tank_id: values.fuel_tank_id,
					fuel_supply_type_id: itemFuelSupplyTypeDetail._id,
					observation: values.observation,
					productive_cycle_id: values.productive_cycle_id,
					establishment_id: transferTankFuelSelect.establishment._id,
					transfer_establishment_id: values.establishment_id,
					// stock: transferTankFuelSelect.stock,
					// balance: balance_transfer,
					unit_measurement_id: fuelTank.unit_measurement_id,
					feeding_barges_id: transferTankFuelSelect.feeding_barges_id,
					fuel_type_id: fuelTypeId,
				};

				dispatch(addNewFuelSupply(fuelSupplyTransfer));
			}

			if (isEdit) {
				fuelSupply._id = dataFuelSupply._id;
				dispatch(updateFuelSupply(fuelSupply));
			} else {
				dispatch(addNewFuelSupply(fuelSupply));

				if (supplyType.code == 'output_transfer') {
					const roles = ['ADM', 'OPE', 'ABS'];
					const establishments = [
						values.establishment_id,
						values.transfer_establishment_id,
					];
					const params = {
						roles: roles.join(','),
						establishment_id: establishments.join(','),
					};

					await dispatch(getUserByRoles(params));
					const subject = 'Traslado de Combustible';
					const message = `Se ha realizado un movimiento de combustible, un transalo de ${
						values.amount
					} ${unitMeasurementName} de ${type} desde establecimiento ${itemEstablishmentDetail.name.toUpperCase()} hacia el establecimiento ${establishment.name.toUpperCase()}. Guía de Despacho N°${
						values.document_number
					}. Realizado por ${user.full_name.toUpperCase()}.`;
					const body = `<div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; line-height: 1.6; color: #333; background-color: #f9f9f9; padding: 20px; border-radius: 8px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
									
									<div style="text-align: center; margin-bottom: 20px;">
											<h1 style="color: COLOR_SECONDARY;">Traslado de Combustible</h1>
									</div>
									
									<p style="margin-bottom: 15px;">Se ha realizado un movimiento de combustible <b>${
										values.amount
									} ${unitMeasurementName}</b> de <b>${type}</b>.</p>
						
									<table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
											<tr>
													<td style="padding: 10px; border: 1px solid #ddd;"><b>Guía de Despacho</b></td>
													<td style="padding: 10px; border: 1px solid #ddd;">N°${
														values.document_number
													}</td>
											</tr>
											<tr>
													<td style="padding: 10px; border: 1px solid #ddd;"><b>Origen</b></td>
													<td style="padding: 10px; border: 1px solid #ddd;">${itemEstablishmentDetail.name.toUpperCase()}</td>
											</tr>
											<tr>
													<td style="padding: 10px; border: 1px solid #ddd;"><b>Destino</b></td>
													<td style="padding: 10px; border: 1px solid #ddd;">${establishment.name.toUpperCase()}</td>
											</tr>
									</table>

									<p style="margin-bottom: 20px;">
											El movimiento fue realizado por <b>${user.full_name.toUpperCase()}</b>.
									</p>

									<div style="margin-top: 30px; text-align: center; font-size: 0.8em;">
											<p>Si tienes alguna pregunta o necesitas asistencia, por favor <a href="mailto:ayuda@openlink.cl" style="color: COLOR_SECONDARY;">contáctanos</a>.</p>
											<p>Gracias. Equipo de Openlink.</p>
									</div>

							</div>
						`;

					if (users.length > 0) {
						const uniqueEmails = [
							...new Set(users.map(user => user.email)),
						].join(',');
						const message_email = {
							to_email: uniqueEmails,
							subject: subject,
							body: body,
						};
						// Enviar el mensaje con dispatch
						dispatch(sendNewEmailMessage(message_email));

						const user_ids = [...new Set(users.map(user => user._id))]; // Sin .join(','), mantiene el array
						const message_notification = {
							title: subject,
							message: message,
							notification_priority_code: 'M',
							notification_type_code: 'INF',
							user_ids: user_ids,
						};
						dispatch(addNewBulkNotification(message_notification));
					}
				}

				if (supplyType.code == 'loss') {
					const roles = ['ADM', 'OPE', 'ABS'];
					const establishments = [values.establishment_id];
					const params = {
						roles: roles.join(','),
						establishment_id: establishments.join(','),
					};

					await dispatch(getUserByRoles(params));
					const subject = 'Merma de Combustible';
					const message = `Se ha realizado registrado un movimiento de merma de combustible, de ${
						values.amount
					} ${unitMeasurementName} de ${type} en el establecimiento ${itemEstablishmentDetail.name.toUpperCase()}. Realizado por ${user.full_name.toUpperCase()}.`;
					const body = `<div style="max-width: 600px; margin: auto; font-family: Arial, sans-serif; line-height: 1.6; 
													color: #333; background-color: #f9f9f9; padding: 20px; border-radius: 8px; 
													box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
									
									<div style="text-align: center; margin-bottom: 20px;">
											<h1 style="color: COLOR_SECONDARY;">Merma de Combustible</h1>
									</div>
									<p style="margin-bottom: 15px;">Se ha realizado un movimiento de merma de combustible <b>${
										values.amount
									} ${unitMeasurementName}</b> de <b>${type}</b>.</p>									
									<table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
											<tr>
													<td style="padding: 10px; border: 1px solid #ddd;"><b>Origen</b></td>
													<td style="padding: 10px; border: 1px solid #ddd;">${itemEstablishmentDetail.name.toUpperCase()}</td>
											</tr>
									</table>
									<p style="margin-bottom: 20px;">
											El movimiento fue realizado por <b>${user.full_name.toUpperCase()}</b>.
									</p>

									<div style="margin-top: 30px; text-align: center; font-size: 0.8em;">
											<p>Si tienes alguna pregunta o necesitas asistencia, por favor <a href="mailto:ayuda@openlink.cl" style="color: COLOR_SECONDARY;">contáctanos</a>.</p>
											<p>Gracias. Equipo de Openlink.</p>
									</div>

							</div>
						`;

					if (users.length > 0) {
						const uniqueEmails = [
							...new Set(users.map(user => user.email)),
						].join(',');
						const message_email = {
							to_email: uniqueEmails,
							subject: subject,
							body: body,
						};
						// Enviar el mensaje con dispatch
						dispatch(sendNewEmailMessage(message_email));

						const user_ids = [...new Set(users.map(user => user._id))]; // Sin .join(','), mantiene el array
						const message_notification = {
							title: subject,
							message: message,
							notification_priority_code: 'M',
							notification_type_code: 'INF',
							user_ids: user_ids,
						};
						dispatch(addNewBulkNotification(message_notification));
					}
				}
			}
			dispatch(getFuelSupplyList({ establishment_id: establishment_id }));
			handleToggleModal();
			setIsLoading(false);
		},
	});

	const [filteredFuelTankList, setFilteredFuelTankList] = useState([]);
	useEffect(() => {
		if (fuelTankListSelect) {
			const filtered = fuelTankListSelect
				.filter(option => {
					const byEstablishment = selectedEstablishment
						? option.item.establishment &&
						  option.item.establishment._id ===
								selectedEstablishment.establishment._id
						: true;

					const byFeedingBarge = validation.values.feeding_barges_id
						? // incluye si no tiene feeding_barges, o si tiene el correcto
						  !option.item.feeding_barges ||
						  option.item.feeding_barges._id ===
								validation.values.feeding_barges_id
						: true;

					return byEstablishment && byFeedingBarge;
				})
				.map(option => ({
					...option,
					label:
						option?.item?.name +
						(option?.item?.feeding_barges?.name
							? ' - ' + option.item.feeding_barges.name
							: ''),
				}));

			setFilteredFuelTankList(filtered);
		} else {
			setFilteredFuelTankList([]);
		}
	}, [
		selectedEstablishment,
		fuelTankListSelect,
		validation.values.feeding_barges_id,
	]);

	const [filteredTransferFuelTankList, setTransferFilteredFuelTankList] =
		useState([]);
	useEffect(() => {
		if (fuelTankListSelect) {
			const filtered = fuelTankListSelect
				.filter(option => {
					const matchesTransfer =
						option?.item?.establishment?._id ===
						validation.values.select_transfer_establishment_id;
					const matchesFuelType =
						option?.item?.fuel_type_id === fuelTank?.fuel_type_id;
					const isNotSameTank = option.item._id !== fuelTank?._id;

					return matchesTransfer && isNotSameTank && matchesFuelType;
				})
				.map(option => ({
					...option,
					label:
						option?.item?.name +
						(option?.item?.feeding_barges?.name
							? ' - ' + option.item.feeding_barges.name
							: ''),
				}));

			setTransferFilteredFuelTankList(filtered);
		} else {
			setTransferFilteredFuelTankList([]);
		}
	}, [
		fuelTank,
		transferEstablishmentsListSelect,
		fuelTankListSelect,
		selectedTransferEstablishment,
	]);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	const handleFuelTankSelect = optionSelected => {
		setFuelTank(optionSelected);
	};

	useEffect(() => {
		if (fuelTank) {
			if (fuelTank?.feeding_barges?.name)
				setFeedingBarges(fuelTank.feeding_barges.name);
			if (fuelTank?.feeding_barges?._id)
				setFeedingBargesId(fuelTank.feeding_barges._id);
			if (fuelTank?.fuel_type_id) setFuelTypeId(fuelTank.fuel_type_id);
			if (fuelTank?.unit_measurement?.name)
				setUnitMeasurement(fuelTank.unit_measurement.name.toUpperCase());
			setCapacity(fuelTank.capacity);
			setStock(fuelTank.stock);
			if (fuelTank?.fuel_type?.name)
				setType(fuelTank.fuel_type.name.toUpperCase());
			validation.setFieldValue(
				'productive_cycle_id',
				fuelTank.productive_cycle?._id || ''
			);
			if (fuelTank.stock) validation.setFieldValue('stock', fuelTank.stock);
			validation.setFieldValue('capacity', fuelTank.capacity || '');
			validation.setFieldValue('type', fuelTank.fuel_type_name || '');
		} else {
			setFeedingBarges('-');
			setCapacity('-');
			validation.setFieldValue('stock', 0, false);
			setType('-');
		}
	}, [fuelTank]);

	const clearForm = () => {
		validation.setFieldValue('document', null);
		validation.setFieldValue('transfer_id', '');
		validation.setFieldValue('transfer_company_id', '');
		validation.setFieldValue('file_type_id', '');
		validation.setFieldValue('document_number', '');

		setCategory('-');
		setFileName(''); // Restablece el nombre si no hay archivo
		setNameTypeDocument('Documento');
	};

	const handleSupplyTypeSelect = optionSelected => {
		if (optionSelected?.direction) {
			validation.setFieldValue('direction', optionSelected?.direction || '');
			setDirection(optionSelected.direction);
			setSupplyType(optionSelected);
		}

		if (optionSelected) {
			setSelectFuelSupplyType(optionSelected.code);
			switch (optionSelected.code) {
				case 'supply':
					// Código para el caso 'supply'
					setCodeTypeDocument('VC,GD');
					setTransferCompanyCol(false);
					setFileCol(false);
					setFileColNumberDoc(false);
					setEstablishmentCol(true);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(false);
					clearForm();
					break;
				case 'output_transfer':
					// Código para el caso 'output_transfer'
					setCodeTypeDocument('GD');
					setNameDirection('Establecimiento de Destino');
					setTransferCompanyCol(true);
					setFileCol(false);
					setFileColNumberDoc(false);
					setEstablishmentCol(false);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(false);
					clearForm();
					break;
				case 'loss':
					// Código para el caso 'loss'
					setCodeTypeDocument('AUT');
					setTransferCompanyCol(true);
					setFileCol(false);
					setFileColNumberDoc(true);
					setEstablishmentCol(true);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(false);
					clearForm();
					break;
				case 'transfer_out':
					// Código para el caso 'transfer'
					setTransferCompanyCol(true);
					setFileCol(true);
					setFileColNumberDoc(true);
					setEstablishmentCol(true);
					setFuelTankCol(false);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(false);
					clearForm();
					break;
				case 'patch':
					// Código para el caso 'patch'
					setCodeTypeDocument('AUT');
					setTransferCompanyCol(true);
					setFileCol(false);
					setFileColNumberDoc(true);
					setEstablishmentCol(true);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(true);
					clearForm();
					break;
				case 'patch_history':
					// Código para el caso 'patch'
					setCodeTypeDocument('AUT');
					setTransferCompanyCol(true);
					setFileCol(false);
					setFileColNumberDoc(true);
					setEstablishmentCol(true);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(true);
					clearForm();
					break;
				case 'consumption':
					// Código para el caso 'consumption'
					setTransferCompanyCol(true);
					setFileCol(true);
					setFileColNumberDoc(true);
					setEstablishmentCol(true);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(false);
					setRequiredDescription(false);
					clearForm();
					break;
				case 'input_transfer':
					// Código para el caso 'input_transfer'
					setCodeTypeDocument('GD');
					setNameDirection('Establecimiento de Origen');
					setTransferCompanyCol(true);
					setFileCol(false);
					setFileColNumberDoc(false);
					setEstablishmentCol(false);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(false);
					clearForm();
				case 'set':
					// Código para el caso 'set'
					setCodeTypeDocument('AUT');
					setTransferCompanyCol(true);
					setFileCol(false);
					setFileColNumberDoc(true);
					setEstablishmentCol(true);
					setFuelTankCol(true);
					setPowerGenerationSourceCol(true);
					setRequiredDescription(false);
					clearForm();
					break;
				default:
					setTransferCompanyCol(false);
					setFileCol(false);
					setFileColNumberDoc(false);
					setEstablishmentCol(false);
					setFuelTankCol(false);
					setPowerGenerationSourceCol(true);
					setMandatoryDescription(true);
					setRequiredDescription(false);
					clearForm();
					break;
			}
		} else {
			setTransferCompanyCol(true);
			setFileCol(true);
			setFileColNumberDoc(true);
			setEstablishmentCol(true);
			setFuelTankCol(true);
			setPowerGenerationSourceCol(true);
			setRequiredDescription(false);
			setSupplyType(null);
			setSelectedTransferEstablishment(null);
		}
	};

	const handleTransferCompanySelect = optionSelected => {
		if (optionSelected) {
			setTransferKey(`transfer_${optionSelected?._id || ''}`);
			setCompany(optionSelected);
		} else {
			setCompany(null);
		}
	};

	const handleTransferSelect = optionSelected => {
		setTransfer(optionSelected);
		setCategory(optionSelected?.transfer_category?.name);
	};

	const handleEstablishmentSelect = optionSelected => {
		setEstablishment(optionSelected || null);
	};

	const handleSelectedEstablishmentSelect = optionSelected => {
		setSelectedEstablishment(optionSelected);

		if (optionSelected) {
			const selectedEstablishmentId = optionSelected.establishment._id;
			validation.setFieldValue('establishment_id', selectedEstablishmentId);
			setTransferEstablishmentListSelect(establishmentsListSelect);
		} else {
			setTransferEstablishmentListSelect([]);
		}
	};

	const handleSelectedTransferEstablishmentSelect = optionSelected => {
		if (optionSelected) {
			setSelectedTransferEstablishment(optionSelected);
		} else {
			setSelectedTransferEstablishment(null);
		}
	};

	const handleTransferTankFuelSelect = optionSelected => {
		if (optionSelected) {
			setTransferTankFuelSelect(optionSelected);
		} else {
			setTransferTankFuelSelect(null);
		}
	};

	const handleTypeDocumentSelect = optionSelected => {
		if (optionSelected && optionSelected.name) {
			setTypeDocument(optionSelected);
			setNameTypeDocument(optionSelected.name);
		} else {
			setNameTypeDocument('Documento');
		}
	};

	const handleFileChange = event => {
		const file = event.currentTarget.files[0];
		validation.setFieldValue('document', file);
		if (file) {
			setFileName(file.name); // Guarda el nombre del archivo
		} else {
			setFileName(''); // Restablece el nombre si no hay archivo
		}
	};

	useEffect(() => {
		validation.setFieldValue('supply_date', new Date());
	}, []);

	const selectorPowerGenerationSource = createSelector(
		state => state.PowerGenerationSource,
		data => ({
			powerGenerationSourceList: data.powerGenerationSourceList,
			powerGenerationSourceListSelect: data.powerGenerationSourceListSelect,
		})
	);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) {
					toast.error(
						'Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.',
						{ autoClose: 4000 }
					);
				}
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					{itemEstablishmentDetail?.establishment_group && (
						<Col lg={3}>
							<OSelect
								key={
									'select_establishment_id' +
									establishmentsListSelect.length
								}
								label='Establecimiento'
								id='select_establishment_id'
								name='select_establishment_id'
								value={validation.values.select_establishment_id || ''}
								onSelect={handleSelectedEstablishmentSelect}
								itemsSelect={establishmentsListSelect}
								validation={validation}
							/>
						</Col>
					)}

					{['SWE', 'LWE'].includes(
						itemEstablishmentDetail?.establishment_type?.code
					) &&
						!itemEstablishmentDetail?.establishment_group && (
							<Col lg={3}>
								<OSelect
									label='Artefacto Naval'
									id='feeding_barges_id'
									name='feeding_barges_id'
									value={validation.values.feeding_barges_id || ''}
									// onSelect={handleFeedingBargesSelect}
									requestApi={() =>
										getFeedingBargesList({
											establishment_id: establishment_id,
										})
									}
									validation={validation}
								/>
							</Col>
						)}
					<Col lg={3}>
						<OSelect
							label='Estanque de Combustible'
							id='fuel_tank_id'
							name='fuel_tank_id'
							key={
								'fuel_tank_id' +
								establishment_id +
								validation.values.feeding_barges_id +
								filteredFuelTankList.length
							}
							isRequired={true}
							value={dataFuelSupply?.fuel_tank_id || ''}
							// handleLabelOptions={(option) => (option.value + (option?.item?.feeding_barges?.name ? ' - ' + option?.item?.feeding_barges?.name : ''))}
							// handleLabelOptions={handleFuelTankLabelOptions}
							onSelect={handleFuelTankSelect}
							itemsSelect={filteredFuelTankList}
							validation={validation}
							// requestApi={() => getFuelTankListByEstablishment({ establishment_id: establishment_id })}
							// requestApi={() => {
							// 	return getFuelTankListByEstablishment({ establishment_id: establishment_id })
							// 		.then(options => {
							// 			if (validation.values.feeding_barges_id) {
							// 				return options.filter(option => option.feeding_barges_id == validation.values.feeding_barges_id);
							// 			}
							// 			return options;
							// 		});
							// }}
						/>
					</Col>
					<Col lg={2}>
						<Label for='type' className='form-label'>
							Tipo Combustible
						</Label>
						<Input
							name='type'
							id='type'
							className='form-control'
							placeholder='-'
							type='text'
							disabled={true}
							value={type}
						/>
					</Col>

					<Col lg={2}>
						<OInput
							name='capacity'
							label={`Capacidad Estanque (${unitMeasurementName})`}
							type='text'
							placeholder='-'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							disabled={true}
							value={capacity}
						/>
					</Col>
					<Col lg={2}>
						<OInput
							name='stock'
							label={`Saldo Estanque (${unitMeasurementName})`}
							type='text'
							placeholder='-'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							disabled={true}
							isRequired={true}
							value={validation.values.stock || ''}
						/>
					</Col>
				</Row>
				<Row className='g-3 mt-1'>
					<Col lg={3}>
						<OSelect
							key={'fuel_supply_type_id'}
							label='Tipo Movimiento'
							id='fuel_supply_type_id'
							name='fuel_supply_type_id'
							isRequired={true}
							value={dataFuelSupply?.fuel_supply_type_id || ''}
							onSelect={handleSupplyTypeSelect}
							requestApi={() =>
								getFuelSupplyTypeList({
									not_in:
										'consumption,input_transfer,transfer_in,supply,output_transfer,patch,patch_history,loss,transfer_out',
								})
							}
							validation={validation}
						/>
					</Col>
					<Col lg={2}>
						<OInput
							name='amount'
							label={`Saldo`}
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							isRequired={true}
							value={validation.values.amount || ''}
						/>
					</Col>

					<Col sm={2}>
						<DatesProvider
							settings={{
								locale: 'es-mx',
								firstDayOfWeek: 1,
								weekendDays: [0],
								timezone: 'UTC',
							}}
						>
							<DatePickerInput
								label={
									<span>
										Fecha del Movimiento{' '}
										<span style={{ color: 'red' }}>*</span>
									</span>
								}
								id='supply_date'
								name='supply_date'
								placeholder='Seleccione una fecha'
								value={
									validation.values.supply_date
										? new Date(validation.values.supply_date)
										: null
								}
								onChange={date => {
									validation.setFieldValue('supply_date', date);
								}}
								onBlur={validation.handleBlur}
								valueFormat='DD-MM-YYYY'
								maxDate={new Date()}
								// minDate={new Date(new Date().setDate(new Date().getDate() - 10))} // Set minDate to 5 days before today
								error={
									validation.touched['supply_date'] &&
									validation.errors['supply_date']
										? validation.errors['supply_date']
										: ''
								}
								clearable={true}
								excludeDate={date => {
									// Excluir todos los días excepto el día 1 de cada mes
									return date.getDate() !== 1;
								}}
							/>
						</DatesProvider>
					</Col>

					{itemEstablishmentDetail?.establishment_group &&
						supplyType &&
						supplyType?.code == 'transfer_out' && (
							<Col lg={2}>
								<OSelect
									key={
										'select_transfer_establishment_id' +
										transferEstablishmentsListSelect.length +
										selectFuelSupplyType
									}
									label='Establecimiento de Destino'
									id='select_transfer_establishment_id'
									name='select_transfer_establishment_id'
									value={
										validation.values
											.select_transfer_establishment_id || ''
									}
									onSelect={handleSelectedTransferEstablishmentSelect}
									itemsSelect={transferEstablishmentsListSelect}
									validation={validation}
								/>
							</Col>
						)}

					<Col lg={3} hidden={establishmentCol}>
						<OSelect
							key={`transfer_establishment_id_${validation.values.establishment_id}_${validation.values.select_transfer_establishment_id}_${validation.values.fuel_tank_id}`}
							label={name_direction}
							id='transfer_establishment_id'
							name='transfer_establishment_id'
							value={validation.values.transfer_establishment_id || ''}
							onSelect={handleEstablishmentSelect}
							requestApi={() => {
								return getEstablishmentList({
									status_code: 'ACT',
								}).then(options => {
									const filteredOptions = options.filter(
										option =>
											option._id !==
											validation.values.establishment_id
									);
									return filteredOptions;
								});
							}}
							validation={validation}
							isRequired={true}
						/>
					</Col>
					<Col lg={3} hidden={fuelTankCol}>
						<OSelect
							key={`transfer_fuel_tank_id_${validation.values.select_transfer_establishment_id}_${dataFuelSupply?.fuel_tank_id}_${validation.values.transfer_establishment_id}_${filteredTransferFuelTankList.length}`}
							label='Estanque de Destino'
							id='transfer_fuel_tank_id'
							name='transfer_fuel_tank_id'
							isRequired={true}
							value={dataFuelSupply?.transfer_fuel_tank_id || ''}
							handleLabelOptions={item =>
								item.name +
								(item?.feeding_barges?.name
									? ' - ' + item?.feeding_barges?.name
									: '')
							}
							onSelect={handleTransferTankFuelSelect}
							itemsSelect={filteredTransferFuelTankList}
							// requestApi={() => {
							// 	return getFuelTankListByEstablishment({ establishment_id: establishment_id })
							// 		.then(options => {
							// 			const filteredOptions = options.filter(option => option._id !== validation.values.fuel_tank_id);
							// 			return filteredOptions;
							// 		});
							// }}
							validation={validation}
						/>
					</Col>
					<Col lg={12}>
						<Label for='observation' className='form-label'>
							Observación{' '}
							<span
								hidden={!requiredDescription}
								style={{ color: 'red' }}
							>
								*
							</span>
						</Label>
						<Input
							name='observation'
							id='observation'
							className='form-control'
							placeholder='Ingrese una observación'
							type='textarea'
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.observation || ''}
							invalid={
								validation.touched.observation &&
								validation.errors.observation
									? true
									: false
							}
						/>
						{validation.touched.observation &&
							validation.errors.observation && (
								<FormFeedback type='invalid'>
									{validation.errors.observation}
								</FormFeedback>
							)}
					</Col>

					<OHr text={'Transporte'} visible={transferCompanyCol} />

					<Col lg={3} hidden={transferCompanyCol} className='mt-0'>
						<OSelect
							key={'transfer_company_id'}
							label='Empresa Proveedor'
							id='transfer_company_id'
							name='transfer_company_id'
							isRequired={true}
							value={validation.values.transfer_company_id || ''}
							onSelect={handleTransferCompanySelect}
							requestApi={() =>
								getTransferCompanyList({ transfer_type_code: 'TCOM' })
							}
							validation={validation}
						/>
					</Col>
					<Col
						lg={3}
						hidden={
							transferCompanyCol ||
							!validation.values.transfer_company_id
						}
						className='mt-0'
					>
						<OSelect
							key={transferKey}
							label='Transporte'
							id='transfer_id'
							name='transfer_id'
							// isRequired={true}
							handleLabelOptions={item =>
								`${item.patent} - ${item.name}`
							}
							value={validation.values.transfer_id || ''}
							onSelect={handleTransferSelect}
							requestApi={() =>
								getTransferList({ transfer_company_id: company?._id })
							}
							validation={validation}
						/>
					</Col>

					<Col
						lg={2}
						hidden={
							transferCompanyCol ||
							!validation.values.transfer_company_id
						}
						className='mt-0'
					>
						<Label for='transfer_category' className='form-label'>
							Tipo Transporte
						</Label>
						<Input
							name='transfer_category'
							id='transfer_category'
							className='form-control'
							placeholder='-'
							type='text'
							disabled={true}
							value={category}
						/>
					</Col>

					<OHr text={'Documentación'} visible={fileCol} />

					<Col lg={3} hidden={fileCol} className='mt-0'>
						<OSelect
							key={
								'file_type_id' + validation.values.fuel_supply_type_id
							}
							label='Tipo Documento'
							id='file_type_id'
							name='file_type_id'
							isRequired={true}
							value={validation.values.file_type_id || ''}
							onSelect={handleTypeDocumentSelect}
							requestApi={() =>
								getFileType({ types: code_type_document })
							}
							validation={validation}
						/>
					</Col>

					<Col lg={2} hidden={fileColNumberDoc} className='mt-0'>
						<OInput
							name='document_number'
							label='Nro. Documento'
							type='text'
							validation={validation}
							classNameLabel='form-label'
							classNameInput='form-control'
							isRequired={true}
						/>
					</Col>
					<Col lg={7} hidden={fileCol} className='mt-0'>
						<OInput
							name='document'
							label={`${name_type_document}`}
							type='file'
							validation={validation}
							onChange={handleFileChange}
							classNameLabel='form-label'
							classNameInput='form-control'
							isRequired={true}
							value={fileName ? undefined : ''}
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 modal-footer-add-btn'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isLoading}
					>
						{isLoading ? (
							<i className='label-icon'>
								<Spinner size='sm' />
							</i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Editar' : 'Cargar'} Movimiento de Combustible
					</button>
				</div>
			</div>
		</Form>
	);
};

export default SetBalanceSupplyForm;
